import React, {
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';

import { ActiveRouteContext as Context } from './types';

const ActiveRouteContext = createContext({} as Context);
export const useActiveRouteContext = () => useContext(ActiveRouteContext);

export const ActiveRouteProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeRoute, setActiveRoute] = useState<Context['activeRoute']>();

  const value = useMemo(() => ({
    activeRoute,
    setActiveRoute
  }), [
    activeRoute,
    setActiveRoute
  ]);

  return (
    <ActiveRouteContext.Provider value={value}>{children}</ActiveRouteContext.Provider>
  );
};